/**
 * Arquivo de Configuração de Links e URLs - White Label
 * 
 * Este arquivo centraliza todos os links externos, redes sociais,
 * telefones e URLs usadas no projeto.
 */

const links = {
  // ============ REDES SOCIAIS ============
  social: {
    whatsapp: {
      url: 'https://api.whatsapp.com/send/?phone=5583976010064&text&type=phone_number&app_absent=0',
      phone: '5583976010064',
      displayPhone: '83 97601-0064',
    },
    instagram: {
      url: 'https://www.instagram.com/onitelecom_/',
      username: '@onitelecom_',
    },
    facebook: {
      url: 'https://www.facebook.com/onitelecom?locale=pt_BR',
      name: 'Oni Telecom',
    },
  },

  // ============ TELEFONES ============
  phones: {
    support: '08007007072',
    supportFormatted: '0800 700 7072',
    whatsappFormatted: '(83) 97601-0064',
    toll_free: {
      number: '08007007072',
      display: '0800 700 7072',
      tel: 'tel:08007007072',
    },
    whatsapp: {
      number: '5583976010064',
      display: '83 97601-0064',
      tel: 'tel:5583976010064',
    },
  },

  // ============ LINKS EXTERNOS ============
  external: {
    centralAssinante: 'https://adm.onitelecom.com.br/central_assinante_web/',
    assineAgora: 'https://adm.onitelecom.com.br/app/inmap-auto-viability',
    verificarViabilidade: 'https://adm.onitelecom.com.br/app/inmap-auto-viability',
    recargaCelular: 'https://adm.onitelecom.com.br/central_assinante_web/',
    recarga: 'https://mio.pagtel.com.br/mio/recarga',
    portalOnigo: 'https://portal.onigo.com.br/login',
    
    // App Stores
    googlePlay: {
      url: 'https://play.google.com/store/apps/details?id=br.onitelecom.onigo&pcampaignid=web_share',
      appId: 'br.onitelecom.onigo',
    },
    appStore: {
      url: '#', // Adicionar quando disponível
      appId: '',
    },
  },

  // ============ ROTAS INTERNAS ============
  routes: {
    home: '/',
    login: '/Login',
    quemSomos: '/Quemsomos',
    ofertasChips: '/OfertasChips',
    entretenimento: '/Entretenimento',
    planos: '/Planos',
    internet: '/Internet',
    paraEmpresas: '/ParaEmpresas',
    monteSeuPlano: '/MonteSeuPlano',
    perguntasFrequentes: '/perguntasfrequentes',
    carrinho: '/carrinho',
    pagarFatura: '/pagar-fatura',
    telefonia: '/Ofertaschips',
    condominios: '/ParaEmpresas',
    blog: '/Blog',
    contratos: '/Contratos',
    atendimento: '/Atendimento',
    ouvidoria: '/Ouvidoria',
  },

  // ============ CATEGORIAS DE MENU ============
  menu: {
    topBar: [
      {
        label: 'Descubra a Oni',
        route: '/Quemsomos',
        icon: 'faBrain',
      },
      {
        label: 'Soluções para Empresas',
        route: '/ParaEmpresas',
        icon: 'faNetworkWired',
      },
      {
        label: 'Conectividade para Condomínios',
        route: '/ParaEmpresas',
        icon: 'faWifi',
      },
      {
        label: 'Tecnologia Sem Limites',
        route: '/perguntasfrequentes',
        icon: 'faBolt',
      },
    ],
    mainNav: [
      { label: 'Planos', route: '/Planos' },
      { label: 'Entretenimento', route: '/Entretenimento' },
      { label: 'Internet', route: '/Internet' },
      { label: 'Telefonia', route: '/Ofertaschips' },
    ],
    mobileNav: [
      { label: 'Página Inicial', route: '/', icon: 'faHome' },
      { label: 'Planos', route: '/Planos', icon: 'faFileContract' },
      { label: 'Entretenimento', route: '/Entretenimento', icon: 'faTv' },
      { label: 'Internet', route: '/internet', icon: 'faWifi' },
      { label: 'Telefonia', route: '/Ofertaschips', icon: 'faPhone' },
      { label: 'Para Empresas', route: '/ParaEmpresas', icon: 'faStoreAlt' },
      { label: 'Condomínios', route: '/ParaEmpresas', icon: 'faCity' },
      { label: 'Central do Assinante', route: 'https://adm.onitelecom.com.br/central_assinante_web/', icon: 'faCog', external: true },
      { label: 'Quem Somos', route: '/Quemsomos', icon: 'faUsers' },
      { label: 'Perguntas Frequentes', route: '/perguntasfrequentes', icon: 'faQuestion' },
    ],
    footer: {
      institucional: [
        { label: 'Quem somos?', route: '/Quem somos?' },
        { label: 'Por que Oni?', route: '/Por que Oni?' },
        { label: 'Blog', route: '/Blog' },
        { label: 'Contratos', route: '/Contratos' },
      ],
      planosServicos: [
        { label: 'Combos', route: '/Combos' },
        { label: 'Internet', route: '/Internet' },
        { label: 'Oni Play', route: '/Oni Play' },
        { label: 'Linha Móvel', route: '/Linha Móvel' },
      ],
      contato: [
        { label: 'Atendimento', route: '/Atendimento' },
        { label: 'Ouvidoria', route: '/Ouvidoria' },
        { label: 'Perguntas Frequentes', route: '/Perguntas Frequentes' },
      ],
    },
  },

  // ============ INFORMAÇÕES DA EMPRESA ============
  company: {
    cnpj: '000.111.333/000',
    licencaAnatel: 'SCM',
    location: {
      default: 'João Pessoa',
      options: [
        { value: 'joaopessoa', label: 'João Pessoa' },
        { value: 'brejinho', label: 'Brejinho' },
      ],
    },
  },
};

/**
 * Função auxiliar para obter um link
 * Uso: getLink('social.whatsapp.url')
 */
export const getLink = (path) => {
  const keys = path.split('.');
  let value = links;
  
  for (const key of keys) {
    value = value[key];
    if (value === undefined) {
      console.warn(`Link não encontrado: ${path}`);
      return '#';
    }
  }
  
  return value;
};

/**
 * Função auxiliar para formatar número de telefone
 */
export const formatPhone = (phone) => {
  // Remove caracteres não numéricos
  const cleaned = phone.replace(/\D/g, '');
  
  // Formata de acordo com o padrão brasileiro
  if (cleaned.length === 11) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
  } else if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
  }
  
  return phone;
};

export default links;
